"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.contactSchema = void 0;
var constants_1 = require("@hobt/constants");
exports.contactSchema = {
    type: 'object',
    additionalProperties: {
        not: true,
        /* eslint-disable-next-line no-template-curly-in-string */
        errorMessage: '- should not have additional property ${0#}',
    },
    required: [
        'correspondenceLanguageCode',
        'emailID',
        'financialInstitutionCode',
        'name',
        'phoneNumber',
    ],
    properties: {
        correspondenceLanguageCode: {
            type: 'number',
            enum: Object.values(constants_1.Language),
            errorMessage: 'Should equate to a valid Language Enum value',
        },
        emailID: {
            type: 'string',
            pattern: '^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\\.[a-zA-Z0-9-.]+$',
            minLength: 1,
            maxLength: 80,
            errorMessage: {
                maxLength: 'Should be a string with exactly 80 characters',
                pattern: constants_1.validationErrorMessage(constants_1.HbtValidationErrorCodes.HBT_VAL_ERR_MUST_BE_A_VALID_EMAIL_FORMAT),
            },
        },
        extensionPhoneNumber: {
            type: ['string', 'null'],
            pattern: '^[0-9]*$',
            minLength: 0,
            maxLength: 7,
            errorMessage: {
                maxLength: 'Should be a string with a maximum of 6 characters or null',
                pattern: constants_1.validationErrorMessage(constants_1.HbtValidationErrorCodes.HBT_VAL_ERR_MUST_CONTAIN_NUMBERS_ONLY),
            },
        },
        financialInstitutionCode: {
            type: 'string',
            pattern: '^[0-9]*$',
            minLength: 1,
            maxLength: 3,
            errorMessage: {
                maxLength: 'Should be a string with a maximum of 3 characters',
                pattern: constants_1.validationErrorMessage(constants_1.HbtValidationErrorCodes.HBT_VAL_ERR_MUST_CONTAIN_NUMBERS_ONLY),
            },
        },
        name: {
            type: 'string',
            pattern: '^[a-zA-ZÀ-ÿ- ]*$',
            minLength: 1,
            maxLength: 40,
            errorMessage: {
                pattern: constants_1.validationErrorMessage(constants_1.HbtValidationErrorCodes.HBT_VAL_ERR_MUST_CONTAIN_ALHPABETS_AND_DASHES_ONLY),
                maxLength: 'Should be a string with a maximum of 40 characters',
            },
        },
        phoneNumber: {
            type: 'string',
            pattern: '^[0-9]*$',
            minLength: 10,
            maxLength: 10,
            errorMessage: {
                maxLength: 'Should be a string with exactly 10 characters',
                pattern: constants_1.validationErrorMessage(constants_1.HbtValidationErrorCodes.HBT_VAL_ERR_MUST_CONTAIN_NUMBERS_ONLY),
            },
        },
    },
};
